import { environment } from 'src/environments/environment';

import { IRoutingService } from './routing.types';
import { DirectionsRoutingService } from './strategies/directions-routing.service';
import { RoutesApiRoutingService } from './strategies/routes-api-routing.service';

export function routingServiceFactory(
  directions: DirectionsRoutingService,
  routesApi: RoutesApiRoutingService,
): IRoutingService {
  const pref = (environment as { routesProvider?: string }).routesProvider || 'directions';
  return pref === 'routes' ? routesApi : directions;
}
